"use strict";

// References
var alt = require("../alt");

class CompanyActions {
    constructor() {
        this.generateActions(
            "clearNotifications",
            "getCompanyData",
            "getDepartments",
            "getBrands",
            "getAllDepartments",
            "getDepartmentDescendants",
            "getDepartmentAccess",
            "getTypes",
            "getLocations",
            "getUsers",
            "getRoles",
            "getRolesPerUser",
            "addBrand",
            "addDepartment",
            "addType",
            "addLocation",
            "addUser",
            "addUserDepartmentAccess",
            "addRole",
            "addRolesPerUser",
            "updateBrand",
            "updateDepartment",
            "updateType",
            "updateLocation",
            "updateUser",
            "updateUserDepartmentAccess",
            "updateRole",
            "updateRolesPerUser",
            "deleteDepartment",
            "deleteType",
            "deleteLocation",
            "deleteUser",
            "deleteUserDepartmentAccess",
            "deleteRole",
            "deleteRolesPerUser",
            "deleteBrand",
        );
    }
}

module.exports = alt.createActions(CompanyActions);



// WEBPACK FOOTER //
// ./app/scripts/actions/CompanyActions.js